jQuery(document).ready(function(){
   new Swiper('.main-images-options.swiper-container', {
      slidesPerView: 1.5,
      loop: false,
     centeredSlides: false,
     breakpoints: {
      320: {                // Mobile ke liye breakpoint (320px se chhote screens ke liye)
        slidesPerView: 1.2,   // Mobile view mein sirf 1 slide dikhaye
        spaceBetween: 3,   // Space beech mein
      },
      768: {                // Tablet aur higher resolution ke liye
        slidesPerView: 1.2, // Tablet view mein 1.5 slides
        spaceBetween: 3,
      }
    },
// If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return `<span class="outer-dot swiper-pagination-bullet" data-index="${
            index + 1
          }"><span class="inner-dot"></span></span>`;
        }
      },
      on: {
            slideChange: function () {
                let updatedIndex = this.realIndex + 1; // 1-based index
                //alert('Current slide index:', this.realIndex);
                
                // Update current slide display
                $('.swiper-slider-current-slide .current-slide').html('Current Slide: ' + updatedIndex);
                
                // Update pagination bullets
                $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');
                
                // Update only the bullet corresponding to the current slide
                $('.swiper-pagination-bullet[data-index="' + updatedIndex + '"]').addClass('swiper-pagination-bullet-active');
            }
        }
    });

  if (window.innerWidth <= 768) {
    new Swiper('.inner-waysoflaces .swiper-container', {
     slidesPerView: 1.2,
      loop: false,
      centeredSlides: false,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return `<span class="outer-dot swiper-pagination-bullet" data-index="${
            index + 1
          }"><span class="inner-dot"></span></span>`;
        }
      }
    });
    new Swiper('.laces-blocks .swiper-container', {
      slidesPerView: 1.2,
      loop: false,
      centeredSlides: false,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return `<span class="outer-dot swiper-pagination-bullet" data-index="${
            index + 1
          }"><span class="inner-dot"></span></span>`;
        }
      }
    });
  }

  var color2 = $('.pdp-swch-img').attr('datache').toLowerCase();
  jQuery('.thumbnails-options .thumb-img[data-alt="'+color2+'"]').show();
  jQuery('.thumbnails-options .thumb-img[data-alt!="'+color2+'"]').hide();
  $('.products-images-sections .thumbnails-options .thumb-img:first-child').addClass('thumb-img-active');

  jQuery(document).on('click', '.pdp-swch-img', function() {
            var color = jQuery(this).attr('datache').toLowerCase();
            const thumbImages = document.querySelectorAll('.thumb-img');
            let matchedIndex = -1;
            for (let index = 0; index < thumbImages.length; index++) {
                const thumbImg = thumbImages[index];
                if (thumbImg.getAttribute('data-alt').toLowerCase() === color) {
                    matchedIndex = index; // Store the index of the first matched image
                    break; // Exit the loop after the first match
                }
            }
            if (matchedIndex !== -1) {
                jQuery('.thumbnails-options .thumb-img').hide();
                const matchingThumbs = jQuery('.thumbnails-options .thumb-img[data-alt="' + color + '"]');
                matchingThumbs.show();
                matchingThumbs.removeClass('thumb-img-active');
                matchingThumbs.first().addClass('thumb-img-active');
            }
    });
    $(document).on('click', '.pdp-custom-swatch-list-item', function() {
          $('.pdp-custom-swatch .pdp-custom-swatch-list-item').removeClass('active');
          let selectedColor = $(this).attr('data-color');
          $(this).addClass('active');
          updatepdpImg(selectedColor);
    });
    function updatepdpImg(selectedColor) {
        $('.current-main-images .thumb-img[data-alt="' + selectedColor + '"]').addClass('showThis');
        $('.current-main-images .thumb-img[data-alt!="' + selectedColor + '"]').removeClass('showThis');
    }
  
    jQuery('.pdp-custom-swatch-list-item').removeClass('active');
    jQuery(this).parent('.pdp-custom-swatch-list-item').addClass('active');
	jQuery('.pdp-custom-styles span.style-click').click(function(){
		var getstyle = $(this).text();
		jQuery('.sek-style-seec').text(getstyle);
	});
	jQuery(document).on('click', '.pdp-swch-img', function() {
		 var getapna = $(this).attr('datache');
		 jQuery('p.selected-swatch-text.desktop.hide_desktop.mobile_fixed.test.new .selected-swatch-text-value').text(getapna);
		 jQuery('p.selected-swatch-text.desktop.hide_desktop.mobile_fixed.test.new').addClass('color-showing');
	});
	var getstyle2 = jQuery('.pdp-custom-styles span.style-click.Selective-style').text();
	jQuery('.sek-style-seec').text(getstyle2);
});